import TCreateEditAward from "types/Award/createEditAward";

const awardItemMapper = (formValues: any): TCreateEditAward => ({
  summary: formValues.summary,
  description: formValues.description,
  artist: formValues.artist.value,
  imageUrl:
    typeof formValues.imageUrl === "string" ? formValues.imageUrl : undefined,
  year: Number(formValues.year.value),
  category: formValues.category.value,
});

export default awardItemMapper;
